import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes, { adminweb } from "../apiConfigs"

export const updatePublishUnpublishDiscussionAPI = createAsyncThunk(
    'auth/publish/discussion',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.adminAction(`course-discussion/visibility`,1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const updatePublishUnpublishDiscussionSlice = createSlice({
    name: 'admin publish discussion',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(updatePublishUnpublishDiscussionAPI.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(updatePublishUnpublishDiscussionAPI.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(updatePublishUnpublishDiscussionAPI.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const updatePublishUnpublishDiscussionReducer = updatePublishUnpublishDiscussionSlice.reducer